import moment from "moment";
import { toast } from "react-toastify";

export const convertThousandSeparator = (value) => {
  const numberWithCommas = value?.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return numberWithCommas;
};

export const convertPhoneNumber = (value) => {
  const cleanedNumber = value.replace(/\D/g, "");
  const convertedNumber = `+1${cleanedNumber}`;
  return convertedNumber;
};

export const paginator = (items, current_page, per_page_items) => {
  let page = current_page || 1,
    per_page = per_page_items || 1,
    offset = (page - 1) * per_page,
    paginatedItems = items.slice(offset).slice(0, per_page_items),
    total_pages = Math.ceil(items.length / per_page);

  return {
    page: page,
    per_page: per_page,
    pre_page: page - 1 ? page - 1 : null,
    next_page: total_pages > page ? page + 1 : null,
    total: items.length,
    total_pages: total_pages,
    data: paginatedItems,
  };
};

export const copyTextToClipboard = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      console.log("Text copied to clipboard");
    })
    .catch((error) => {
      console.error("Failed to copy text: ", error);
    });
};

export const validatePhoneNumber = (number) => {
  var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return number.match(phoneno);
};

export const validateEmail = (email) => {
  const validEmailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return validEmailRegex.test(email);
};

// Password Validation
export const isValidPasswordLength = (password) => {
  // Minimum length is 12 characters
  if (password.length < 12) {
    return false;
  }
  return true;
};

export const isValidNumberInPassword = (password) => {
  // Contains at least 1 number
  if (!/\d/.test(password)) {
    return false;
  }
  return true;
};

export const isValidSpecialCharacterInPassword = (password) => {
  // Contains at least 1 special character
  if (!/[^A-Za-z0-9\s]/.test(password)) {
    return false;
  }
  return true;
};

export const isValidUppercaseInPassword = (password) => {
  // Contains at least 1 uppercase letter
  if (!/[A-Z]/.test(password)) {
    return false;
  }
  return true;
};

export const isValidLowercaseInPassword = (password) => {
  // Contains at least 1 lowercase letter
  if (!/[a-z]/.test(password)) {
    return false;
  }
  return true;
};

export const isValidDate = (date) => {
  if (/^\d{4}-\d{2}-\d{2}/.test(date)) {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime());
  }
  return false;
};

export const exportToCsv = (data, toExclude = [], fileType) => {
  if (data.length === 0) {
    toast.error("No data to export");
    return;
  }

  const headers = Object.keys(data[0])
    .filter(key => !toExclude.includes(key))
    .join(',') + '\n';
  const rows = data.map(row => {
    return Object.keys(row)
      .filter(key => !toExclude.includes(key))
      .map(key => {
        const val = row[key];
        if (val && isValidDate(val)){
          return moment(val).format("MM/DD/YYYY");
        }
        if (typeof val === 'string' && (val.includes(',') || val.includes('"') || val.includes('\n'))) { 
          return `"${val.replace(/"/g, '""')}"`; 
        }
        return val;
      })
      .join(',');
  }).join('\n');
  const content = headers + rows;
  
  // Add UTF-8 BOM (Byte Order Mark) for Excel compatibility
  const utf8BOM = '\uFEFF';
  const contentWithBOM = utf8BOM + content;

  try{
    const blob = new Blob([contentWithBOM], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileType}-${moment(new Date()).format("YYYY-MM-DD")}.csv`; 
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  } catch (error){
    toast.error("Failed to export CSV. Please try again.");
  }
};
